import {useRef, useState} from 'react';
import {useMediaQuery} from 'react-responsive';
import {useSwipeable} from 'react-swipeable';
import "./TheCoffeesWeChoose.css";

export const TheCoffeesWeChoose = () => {
  const [currentSlide, setSlide] = useState(1);
  const currentMobileSlide = useRef(1);
  const [carouselClasses, setCarouselClasses] = useState(['theCoffeesCarousel', 'carouselInitialMove', 'theCoffeesCarouselTransition']);
  const isMobile = useMediaQuery({query: '(max-width: 800px)' });

  const totalSlides = 15;
  const slidesToShow = isMobile ? 1 : 3;
  const carouselStartLeft = isMobile ? -85.0 : -33.33;
  const carouselMoveLeft = isMobile ? 90.0 : 33.33;
  const [carouselLeft, setCarouselLeft] = useState( (isMobile ? -85.0 : -33.33) );
  const restartOffset = isMobile ? 5.0 : 0.0;

  const increaseCarousel = () => {
    var carousel = document.getElementById('desktopCarousel');
    const maxSlide = 11;
    let newSlide = currentSlide;
    let newLeft = carouselLeft;//.current;

    if (newSlide === maxSlide + 1) {

        carousel.classList.remove('theCoffeesCarouselTransition');

        newSlide = 1;
        setSlide(newSlide);

        newLeft = carouselStartLeft;
        setCarouselLeft(newLeft);
        carousel.style.left = newLeft.toString() + '%';

        let offset = carousel.offsetHeight;
        carousel.classList.add('theCoffeesCarouselTransition');

    }


    if (newSlide<totalSlides-slidesToShow) {
        newSlide++;
        setSlide(newSlide);

        newLeft -= carouselMoveLeft; //33.33;
        setCarouselLeft(newLeft);
        carousel.style.left = newLeft.toString() + "%";
    }

  };

  const decreaseCarousel = () => {
    var carousel = document.getElementById('desktopCarousel');
    const maxSlide = 11;
    let newSlide = currentSlide;
    let newLeft = carouselLeft;//.current;

    if (newSlide === 1) {
        //move to end
        carousel.classList.remove('theCoffeesCarouselTransition');

        newSlide = maxSlide + 1;
        setSlide(newSlide);
        newLeft = restartOffset + (parseFloat(newSlide) * -carouselMoveLeft); //-33.33;
        setCarouselLeft(newLeft);
        carousel.style.left = newLeft.toString() + '%';

        let offset = carousel.offsetHeight;

        carousel.classList.add('theCoffeesCarouselTransition');

    }

    if (newSlide > 0) {
        newSlide--;
        setSlide(newSlide);
        newLeft += carouselMoveLeft; //33.33;
        setCarouselLeft(newLeft);
        carousel.style.left = newLeft.toString() + "%";
    }

  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => increaseCarousel(),
    onSwipedRight: () => decreaseCarousel(),
    preventDefaultTouchmoveEvent: true
  });


  return (
    <div id="coffees" className="theCoffees" >
        <div className="theCofeesTitle" >
        The coffees we choose
        </div>
        <div className="theCoffeesBody" >
        We made Fellow Drops to share our favorite coffees and showcase interesting new ones: from unique processing methods to underground micro-roasters. Here are a few of our past drops...
        </div>
        <div className="theCoffeesCarouselOuter">
        <div className="theCoffeesCarouselContainer">
          <div id="desktopCarousel" className={carouselClasses.join(' ')} style={{left: '-33.33' }} {...swipeHandlers}>

            {/* start with last for infinite scroll */}
            <div id="carousel11z" className="carouselDiv" >
                <img alt="Onyx" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Onyx_2.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >ONYX</div>
                    <div className="carouselOverlayText">
                    An incredible natural process lot from Las Lajas micromill in Costa Rica: clean, light, and raspberry-tart.
                    </div>
                </div>
            </div>

            <div id="carousel1" className="carouselDiv" >
                <img alt="Elixr" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Elixir.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >ELIXR COFFEE</div>
                    <div className="carouselOverlayText">
                    A truly stellar washed Wush Wush from the roasters responsible for some of our favorite coffees of the year.
                    </div>
                </div>
            </div>
            <div id="carousel2" className="carouselDiv" >
                <img alt="Proud Mary" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Proud_Mary.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >PROUD MARY</div>
                    <div className="carouselOverlayText">
                    A long washing process resulted in an Ethiopian coffee we could drink all day and still find some new fruity note.
                    </div>
                </div>
            </div>
            <div id="carousel3" className="carouselDiv" >
                <img alt="Onyx" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Onyx_taster_flight.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >ONYX</div>
                    <div className="carouselOverlayText">
                    Our bestselling collaboration with Onyx: a tasting flight of four coffees including an exclusive microlot.
                    </div>
                </div>
            </div>

            <div id="carousel4" className="carouselDiv" >
                <img alt="PT's Coffee" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Pts.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >PT'S COFFEE</div>
                    <div className="carouselOverlayText">
                    The Good Food Award-winners premiered this Ethiopian roast on Drops: a sublime cup of lingering sweetness.
                    </div>
                </div>
            </div>
            <div id="carousel5" className="carouselDiv" >
                <img alt="Bold Bean" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Bold_Bean.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >BOLD BEAN</div>
                    <div className="carouselOverlayText">
                    From the volcanic soils of Kenya's Great Rift Valley, this coffee surprised us with notes of cantaloupe and honey.
                    </div>
                </div>
            </div>
            <div id="carousel6" className="carouselDiv" >
                <img alt="Spectrum Coffees" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Spectrum.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >SPECTRUM COFFEES</div>
                    <div className="carouselOverlayText">
                    A small yield shade-grown Ethiopian with notes of floral honey and peach rings: mellow and delicate.
                    </div>
                </div>
            </div>


            <div id="carousel7" className="carouselDiv" >
                <img alt="Dune" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/dune.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >DUNE</div>
                    <div className="carouselOverlayText">
                    A pure experience of tropical fruit from Juan Pena's legendary Cup of Excellence-winning farm in Ecuador.
                    </div>
                </div>
            </div>
            <div id="carousel8" className="carouselDiv" >
                <img alt="JBC" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/JBC.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >JBC</div>
                    <div className="carouselOverlayText">
                    We were struck by the unique and wild notes of sweet pineapple and tea in this Kenyan peaberry: a true original.
                    </div>
                </div>
            </div>
            <div id="carousel9" className="carouselDiv" >
                <img alt="Olympia" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Olympia_coffee.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >OLYMPIA COFFEE</div>
                    <div className="carouselOverlayText">
                    This small Guatemalan lot from a stellar new single producer is like a cup of berries and whipped cream.
                    </div>
                </div>
            </div>


            <div id="carousel10" className="carouselDiv" >
                <img alt="Passenger" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Passenger.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >PASSENGER COFFEE</div>
                    <div className="carouselOverlayText">
                    From one of Ethiopia's most renowned coffee co-ops, a cup of Meyer lemon-sweetened black tea.
                    </div>
                </div>
            </div>
            <div id="carousel11" className="carouselDiv" >
                <img alt="Onyx" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Onyx_2.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >ONYX</div>
                    <div className="carouselOverlayText">
                    An incredible natural process lot from Las Lajas micromill in Costa Rica: clean, light, and raspberry-tart.
                    </div>
                </div>
            </div>


            {/* repeat first three */}
            <div id="carousel1a" className="carouselDiv" >
                <img alt="Elixr Coffee" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Elixir.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >ELIXR COFFEE</div>
                    <div className="carouselOverlayText">
                    A truly stellar washed Wush Wush from the roasters responsible for some of our favorite coffees of the year.
                    </div>
                </div>
            </div>
            <div id="carousel2a" className="carouselDiv" >
                <img alt="Proud Mary" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Proud_Mary.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >PROUD MARY</div>
                    <div className="carouselOverlayText">
                    A long washing process resulted in an Ethiopian coffee we could drink all day and still find some new fruity note.
                    </div>
                </div>
            </div>
            <div id="carousel3a" className="carouselDiv" >
                <img alt="Onyx" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Coffee_Carousel/Onyx_taster_flight.webp"} className="carouselImage" width="100%" height="100%"/>
                <div className="carouselImgOverlay">
                    <div className="carouselOverlayTitle" >ONYX</div>
                    <div className="carouselOverlayText">
                    Our bestselling collaboration with Onyx: a tasting flight of four coffees including an exclusive microlot.
                    </div>
                </div>
            </div>

          </div>
        </div> {/* end contaier */}
        
            <div id="carouselLeft" className={"toggle carouselLeft"} data-toggle='prev' onClick={decreaseCarousel}>
                <img alt="Left" className="carouselLeftImg" src="/images/landing/Illustrations/Various_Illustrations/black_arrow_right.svg"/>
            </div>
            <div id="carouselRight" className={"toggle carouselRight"} data-toggle='next' onClick={increaseCarousel}>
                <img alt="Right" src="/images/landing/Illustrations/Various_Illustrations/black_arrow_right.svg"/>
            </div>

        </div> {/* end outer container */}



    </div>
  );
}

